import * as React from 'react';

export const CookieContent: React.FC = () => (
  <div className='flex flex-col gap-6 text-left'>
    <div className='mb-4'>
      <h1 className='mb-2 font-sans text-24 font-bold leading-[32px] text-brand-800 md:text-32 md:leading-[40px]'>
        Cookie Policy
      </h1>
    </div>

    <section>
      <p className='font-sans text-16 font-normal leading-24 text-gray-600'>
        The Website www.dechoes.com in relation to which this Cookie Policy is issued, is managed by
        DECHOAI S.R.L., with registered office at IF.Voluntari, Blvd. Pipera 1-VIIIM,T4B10
        registered under no. J2025063859004, fiscal code 52387032.
        <br />
        <br />
        In the following section, the users of the Website can identify the types of cookies used by
        the Website and other relevant information about the types of cookies, their purposes,
        personal data collected, how they can be managed and how the users may exercise their
        rights.
      </p>
    </section>

    <section>
      <h4 className='mb-[10px] font-sans text-18 font-medium leading-25 text-dark-100 md:text-20 md:leading-27'>
        1. What are cookies?
      </h4>
      <p className='font-sans text-16 font-normal leading-24 text-gray-600'>
        Cookies are small text files stored on your device when you visit a website. Under the GDPR
        and the ePrivacy Directive, cookies that are not strictly necessary require your prior
        consent.
        <br />
        <br />
        In other words, the website remembers the steps taken by the user when browsing, the
        preferences (e.g. language, settings etc.), so that they do not need to be entered again
        when the user visits the website again or browses from one page to another on it. The
        cookies are therefore used for recognition of authentications, session monitoring and for
        saving the information regarding the activities of users accessing a website. By a unique
        identifier code, cookies can keep track of the user&apos;s browsing within the website for
        statistical or advertising purposes.
        <br />
        <br />
        When browsing a website, the users can also receive on their computer or mobile device
        cookies from different web servers or visited websites (&ldquo;third party cookies&rdquo;).
        <br />
        <br />
        When some functions cannot be carried out without using cookies, such are technical cookies
        which shall be used by the website without the user&apos;s consent as are essential for the
        proper function of the website.
        <br />
        <br />
        Depending on their characteristics and functions, cookies can stay on the user&apos;s
        computer or mobile device for different lengths of time: session cookies, which are
        automatically deleted when the browser is closed; and persistent cookies, which remain on
        the user&apos;s device until a pre-established deadline.
        <br />
        <br />
        Some cookies create a user profile. The &ldquo;profiling cookies&rdquo; are used to send
        advertising messages in line with the preferences expressed when browsing the Internet and
        such type of cookie require the user&apos;s consent.
        <br />
        <br />
        When the user allowed some cookies by expressing the consent, such user can anytime withdraw
        it by accessing the cookies settings panel on the browser.
      </p>
    </section>

    <section>
      <h4 className='mb-[10px] font-sans text-18 font-medium leading-25 text-dark-100 md:text-20 md:leading-27'>
        2. What cookies do we use on the Website
      </h4>
      <h5 className='mb-2 mt-4 font-sans text-16 font-bold leading-24 text-gray-600'>
        2.1. Technical, functional cookies
      </h5>
      <div className='overflow-x-auto'>
        <table className='min-w-[600px] border border-gray-300 font-sans text-16 leading-24 text-gray-600'>
          <thead>
            <tr className='bg-gray-100'>
              <th className='border border-gray-300 px-4 py-2 text-left font-semibold'>
                cookie name
              </th>
              <th className='border border-gray-300 px-4 py-2 text-left font-semibold'>supplier</th>
              <th className='border border-gray-300 px-4 py-2 text-left font-semibold'>purpose</th>
              <th className='border border-gray-300 px-4 py-2 text-left font-semibold'>
                Storage term
              </th>
              <th className='border border-gray-300 px-4 py-2 text-left font-semibold'>
                Location of data
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className='border border-gray-300 px-4 py-2' colSpan={5}>
                No technical cookies currently configured
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <section>
      <h5 className='mb-2 mt-4 font-sans text-16 font-bold leading-24 text-gray-600'>
        2.2. Advertising & Marketing Cookies
      </h5>
      <p className='font-sans text-16 font-normal leading-24 text-gray-600'>
        With your consent, we use advertising cookies to:
      </p>
      <ul className='list-disc pl-5 font-sans text-16 font-normal leading-24 text-gray-600 marker:text-brand-800'>
        <li>Measure the effectiveness of advertising campaigns</li>
        <li>Track conversions</li>
        <li>Build custom and lookalike audiences</li>
        <li>Display personalised advertisements on third-party platforms</li>
      </ul>
      <p className='mt-4 font-sans text-16 font-normal leading-24 text-gray-600'>
        These cookies may collect personal data such as IP address, device identifiers, browser
        information, interaction data, preferences.
        <br />
        <br />
        In detail, the following advertising and marketing cookies are on the Website.
      </p>
      <div className='mt-4 overflow-x-auto'>
        <table className='min-w-[600px] border border-gray-300 font-sans text-16 leading-24 text-gray-600'>
          <thead>
            <tr className='bg-gray-100'>
              <th className='border border-gray-300 px-4 py-2 text-left font-semibold'>
                cookie name
              </th>
              <th className='border border-gray-300 px-4 py-2 text-left font-semibold'>supplier</th>
              <th className='border border-gray-300 px-4 py-2 text-left font-semibold'>purpose</th>
              <th className='border border-gray-300 px-4 py-2 text-left font-semibold'>
                Storage term
              </th>
              <th className='border border-gray-300 px-4 py-2 text-left font-semibold'>
                Location of data
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className='border border-gray-300 px-4 py-2' colSpan={5}>
                No marketing cookies currently configured
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <section>
      <h5 className='mb-2 mt-4 font-sans text-16 font-bold leading-24 text-gray-600'>
        2.3. Third-Party Advertising Tools
      </h5>

      <h6 className='mb-2 mt-4 font-sans text-16 font-semibold leading-24 text-gray-600'>
        Facebook Pixel
      </h6>
      <p className='font-sans text-16 font-normal leading-24 text-gray-600'>
        We use the Facebook Pixel provided by Meta Platforms.
        <br />
        The Facebook Pixel enables us to:
      </p>
      <ul className='list-disc pl-5 font-sans text-16 font-normal leading-24 text-gray-600 marker:text-brand-800'>
        <li>Track user behavior after clicking our Facebook or Instagram ads</li>
        <li>Measure conversions</li>
        <li>Optimise advertising campaigns</li>
      </ul>
      <p className='mt-2 font-sans text-16 font-normal leading-24 text-gray-600'>
        Usually, they are stored in the user&apos;s computer for about 90 days.
        <br />
        Meta Privacy Policy can be found here:{' '}
        <a
          href='https://www.facebook.com/privacy/policy/'
          target='_blank'
          rel='noopener noreferrer'
          className='text-brand-800 underline hover:opacity-80'
        >
          https://www.facebook.com/privacy/policy/
        </a>
      </p>

      <h6 className='mb-2 mt-4 font-sans text-16 font-semibold leading-24 text-gray-600'>
        Google Ads
      </h6>
      <p className='font-sans text-16 font-normal leading-24 text-gray-600'>
        We use Google Ads, a service provided by Google.
        <br />
        Google Ads cookies allow us to:
      </p>
      <ul className='list-disc pl-5 font-sans text-16 font-normal leading-24 text-gray-600 marker:text-brand-800'>
        <li>Measure ad performance</li>
        <li>Display relevant advertisements</li>
        <li>Perform conversion tracking</li>
      </ul>
      <p className='mt-2 font-sans text-16 font-normal leading-24 text-gray-600'>
        Usually, they are stored in the user&apos;s computer for about 90 days.
        <br />
        Google Privacy Policy:{' '}
        <a
          href='https://policies.google.com/privacy'
          target='_blank'
          rel='noopener noreferrer'
          className='text-brand-800 underline hover:opacity-80'
        >
          https://policies.google.com/privacy
        </a>
      </p>
    </section>

    <section>
      <h4 className='mb-[10px] font-sans text-18 font-medium leading-25 text-dark-100 md:text-20 md:leading-27'>
        3. International Data Transfers
      </h4>
      <p className='font-sans text-16 font-normal leading-24 text-gray-600'>
        Some of our advertising partners may process personal data outside the European Economic
        Area (EEA). Where this occurs, we ensure that appropriate safeguards are in place, such as:
      </p>
      <ul className='list-disc pl-5 font-sans text-16 font-normal leading-24 text-gray-600 marker:text-brand-800'>
        <li>Standard Contractual Clauses (SCCs)</li>
        <li>Adequacy decisions by the European Commission</li>
      </ul>
    </section>

    <section>
      <h4 className='mb-[10px] font-sans text-18 font-medium leading-25 text-dark-100 md:text-20 md:leading-27'>
        4. Consent Management
      </h4>
      <p className='font-sans text-16 font-normal leading-24 text-gray-600'>
        When you first visit our website, you will be presented with a cookie consent banner
        allowing you to:
      </p>
      <ul className='list-disc pl-5 font-sans text-16 font-normal leading-24 text-gray-600 marker:text-brand-800'>
        <li>Accept all cookies</li>
        <li>Reject non-essential cookies</li>
        <li>Customize your preferences</li>
      </ul>
      <p className='mt-4 font-sans text-16 font-normal leading-24 text-gray-600'>
        Advertising cookies are disabled by default and will only be activated after you give
        consent.
        <br />
        <br />
        You can change or withdraw your consent at any time via:
      </p>
      <ul className='list-disc pl-5 font-sans text-16 font-normal leading-24 text-gray-600 marker:text-brand-800'>
        <li>Our cookie settings panel</li>
        <li>Your browser settings</li>
      </ul>

      <div className='mt-4 space-y-2'>
        <p className='font-sans text-16 font-semibold leading-24 text-gray-600'>Mozilla Firefox</p>
        <p className='font-sans text-16 font-normal leading-24 text-gray-600'>
          <a
            href='https://support.mozilla.org/en-US/kb/clear-cookies-and-site-data-firefox'
            target='_blank'
            rel='noopener noreferrer'
            className='text-brand-800 underline hover:opacity-80'
          >
            Clear cookies and site data in Firefox | Firefox Help
          </a>
        </p>

        <p className='mt-2 font-sans text-16 font-semibold leading-24 text-gray-600'>
          Safari (Mac)
        </p>
        <p className='font-sans text-16 font-normal leading-24 text-gray-600'>
          <a
            href='https://support.apple.com/en-gb/guide/safari/sfri11471/mac'
            target='_blank'
            rel='noopener noreferrer'
            className='text-brand-800 underline hover:opacity-80'
          >
            Clear cookies in Safari on Mac – Apple Support
          </a>
        </p>

        <p className='mt-2 font-sans text-16 font-semibold leading-24 text-gray-600'>
          Microsoft Edge
        </p>
        <p className='font-sans text-16 font-normal leading-24 text-gray-600'>
          <a
            href='https://support.microsoft.com/en-us/windows/manage-cookies-in-microsoft-edge-view-allow-block-delete-and-use-168dab11-0753-043d-7c16-ede5947fc64d'
            target='_blank'
            rel='noopener noreferrer'
            className='text-brand-800 underline hover:opacity-80'
          >
            Manage cookies in Microsoft Edge
          </a>
        </p>

        <p className='mt-2 font-sans text-16 font-semibold leading-24 text-gray-600'>
          Internet Explorer (for older versions)
        </p>
        <p className='font-sans text-16 font-normal leading-24 text-gray-600'>
          <a
            href='https://support.microsoft.com/en-us/topic/how-to-delete-cookie-files-in-internet-explorer-bca9446f-d873-78de-77ba-d42645fa52fc'
            target='_blank'
            rel='noopener noreferrer'
            className='text-brand-800 underline hover:opacity-80'
          >
            Delete and manage cookies in Internet Explorer
          </a>
        </p>

        <p className='mt-2 font-sans text-16 font-semibold leading-24 text-gray-600'>
          Google Chrome
        </p>
        <p className='font-sans text-16 font-normal leading-24 text-gray-600'>
          <a
            href='https://support.google.com/chrome/answer/95647'
            target='_blank'
            rel='noopener noreferrer'
            className='text-brand-800 underline hover:opacity-80'
          >
            Delete, allow, and manage cookies in Chrome
          </a>
        </p>

        <p className='mt-2 font-sans text-16 font-semibold leading-24 text-gray-600'>Opera</p>
        <p className='font-sans text-16 font-normal leading-24 text-gray-600'>
          <a
            href='https://help.opera.com/en/latest/web-preferences/'
            target='_blank'
            rel='noopener noreferrer'
            className='text-brand-800 underline hover:opacity-80'
          >
            Web preferences - Opera Help
          </a>
        </p>

        <p className='mt-4 font-sans text-16 font-normal leading-24 text-gray-600'>
          More information about cookies can be found on AboutCookies.org.
        </p>
      </div>
    </section>

    <section>
      <h4 className='mb-[10px] font-sans text-18 font-medium leading-25 text-dark-100 md:text-20 md:leading-27'>
        5. Your Rights Under GDPR
      </h4>
      <p className='font-sans text-16 font-normal leading-24 text-gray-600'>
        You have the right to:
      </p>
      <ul className='list-disc pl-5 font-sans text-16 font-normal leading-24 text-gray-600 marker:text-brand-800'>
        <li>Access your personal data</li>
        <li>Rectify inaccurate data</li>
        <li>Erase your data</li>
        <li>Restrict or object to processing</li>
        <li>
          Withdraw consent at any time, without such withdrawal to affect the processing made before
          such withdrawal
        </li>
        <li>
          Submit a complaint to the Data protection Supervisor Authority at www.dataprotection.ro
        </li>
      </ul>
      <p className='mt-4 font-sans text-16 font-normal leading-24 text-gray-600'>
        To exercise your rights, please contact us at: support@dechoai.com
      </p>
    </section>

    <section>
      <h4 className='mb-[10px] font-sans text-18 font-medium leading-25 text-dark-100 md:text-20 md:leading-27'>
        6. Changes to This Policy
      </h4>
      <p className='font-sans text-16 font-normal leading-24 text-gray-600'>
        We may update this Cookie Policy to reflect legal or technical changes. Any updates will be
        published on this page.
      </p>
    </section>
  </div>
);
